export const moduloUm = [
    {
        "id": "1",
        "arquivo": "Mercado Pago_Mercado Financeiro_Parte I_v2.pdf",
        "path": "./treinamento/Mercado Pago_Mercado Financeiro_Parte I_v2.pdf",
        "type": "pdf"
    },
    {
        "id": "2",
        "arquivo": "Mercado Pago_Mercado Financeiro_Parte II_1.pdf",
        "path": "./treinamento/Mercado Pago_Mercado Financeiro_Parte II_1.pdf",
        "type": "pdf"
    },
    {
        "id": "3",
        "arquivo": "Treinamento.pdf",
        "path": "./treinamento/Treinamento.pdf",
        "type": "pdf"
    },
    {
        "id": "4",
        "arquivo": "Estruturacao de Fundos_Aplicacao em Aula.pdf",
        "path": "./treinamento/Estruturacao de Fundos_Aplicacao em Aula.pdf",
        "type": "pdf"
    },
    {
        "id": "5",
        "arquivo": "FIDC-Lamina-v.diagramada.pdf",
        "path": "./treinamento/FIDC-Lamina-v.diagramada.pdf",
        "type": "pdf"
    },
    {
        "id": "6",
        "arquivo": "LAMINA MULTIMERCADO.pdf",
        "path": "./treinamento/LAMINA MULTIMERCADO.pdf",
        "type": "pdf"
    },
    {
        "id": "7",
        "arquivo": "Regulamento FIDC.pdf",
        "path": "./treinamento/Regulamento FIDC.pdf",
        "type": "pdf"
    },
    {
        "id": "8",
        "arquivo": "Regulamento Multimercado.pdf",
        "path": "./treinamento/Regulamento Multimercado.pdf",
        "type": "pdf"
    },
    {
        "id": "9",
        "arquivo": "Mercado Pago_Mercado Financeiro_Derivativos.pdf",
        "path": "./treinamento/Mercado Pago_Mercado Financeiro_Derivativos.pdf",
        "type": "pdf"
    },
    {
        "id": "10",
        "arquivo": "Derivativos.xlsx",
        "path": "./treinamento/Derivativos.xlsx",
        "type": "xlsx"
    },
    {
        "id": "11",
        "arquivo": "cotas securitizacao.xlsx",
        "path": "./treinamento/cotas securitizacao.xlsx",
        "type": "xlsx"
    },
    {
        "id": "12",
        "arquivo": "Mercado Pago_Mercado Financeiro_Resumo.pdf",
        "path": "./treinamento/Mercado Pago_Mercado Financeiro_Resumo.pdf",
        "type": "pdf"
    },
]

export const moduloDois = [
    {
        "id": "1",
        "arquivo": "C2P_Módulo2.pdf",
        "path": "./treinamento/C2P_Modulo2.pdf",
        "type": "pdf"
    },
    {
        "id": "2",
        "arquivo": "demonstracao_financeira_MPB_062025_FINAL.pdf",
        "path": "./treinamento/demonstracao_financeira_MPB_062025_FINAL.pdf",
        "type": "pdf"
    },
    {
        "id": "3",
        "arquivo": "Exemplo.xlsx",
        "path": "./treinamento/Exemplo.xlsx",
        "type": "pdf"
    },
]

export const moduloTres = [
    {
        "id": "1",
        "arquivo": "Gestão de Risco.pdf",
        "path": "./treinamento/Gestao de Risco.pdf",
        "type": "pdf"
    },
    {
        "id": "2",
        "arquivo": "Derivativos_Sadia.xlsx",
        "path": "./treinamento/Derivativos_Sadia.xlsx",
        "type": "xlsx"
    },
]